import { render } from "./TelInput.vue?vue&type=template&id=d0dd0fe0&lang=pug"
import script from "./TelInput.vue?vue&type=script&lang=ts"
export * from "./TelInput.vue?vue&type=script&lang=ts"
script.render = render

export default script